<app-impersonation-confirm-modal
  testId="impersonate-company-admin-dialog"
  *ngIf="confirmVisible && company"
  titleId="company-impersonate-admin-title"
  title="Impersonate admin"
  [busy]="busy"
  (cancel)="closeConfirm()"
  (confirm)="onConfirmImpersonate()"
>
  Start an impersonation session for <strong>“{{ company.name }}”</strong> as {{ adminLabel }}? A
  new tab will open with the shop admin session.
</app-impersonation-confirm-modal>

<div class="impersonate-admin" *ngIf="company as current">
  <div class="impersonate-admin__card">
    <div class="impersonate-admin__details">
      <h2 class="impersonate-admin__heading">Admin account</h2>
      <p class="impersonate-admin__name">{{ current.admin_name || 'Unnamed admin' }}</p>
      <p class="impersonate-admin__email">{{ current.admin_email || 'No email on file' }}</p>
    </div>

    <button
      type="button"
      class="btn btn-primary btn-medium"
      [disabled]="busy || confirmVisible || !canImpersonate"
      (click)="openConfirm()"
    >
      {{ busy ? 'Opening…' : 'Impersonate' }}
    </button>
  </div>

  <p class="impersonate-admin__warning" *ngIf="!canImpersonate">
    This company has no admin user id, so an admin session cannot be started. Impersonating staff or
    a tunnel display may still work.
  </p>
</div>
